<template>
  <div class="login">
    <img src="@/assets/image/logo.png" alt="logo" />
    <h2>{{ doorName }}</h2>
    <van-form @submit="onSubmit">
      <van-field
        v-model.trim="username"
        name="username"
        placeholder="用户名"
        :rules="[{required: true, message: '请填写用户名'}]"
      />
      <van-field
        v-model.trim="password"
        type="password"
        name="password"
        placeholder="密码"
        :rules="[{message: '请填写正确的密码', validator: value => value.length >= 6}]"
      />
      <div style="margin: 16px;">
        <div class="forget">
          <span @click="$router.push('/forgetPwd')">忘记密码</span>
        </div>
        <van-button round block type="info" native-type="submit">
          登 录
        </van-button>
        <div class="regist">
          <span @click="$router.push('/regist')">注册账号</span>
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import {login} from '@/api'
import {getUrlMap} from '@/ultis'
export default {
  data() {
    return {
      username: '',
      password: ''
    }
  },
  created() {
    if (localStorage.getItem('Authorization')) {
      this.$router.replace('/')
    }
  },
  mounted() {
    this.redirect = getUrlMap(location.href).redirect
    console.log(decodeURIComponent(this.redirect))
  },
  methods: {
    onSubmit(values) {
      const params = {
        userName: values.username,
        password: values.password,
        checkCode: '',
        checkCodeSessionId: '',
        loginType: 1,
        tenantId: ''
      }
      login(params).then(res => {
        const {operationType} = res.data
        if (operationType === 5) {
          const token = 'Bearer ' + res.data.userToken.accessToken
          localStorage.setItem('Authorization', token)
          if (this.redirect) {
            location.replace(decodeURIComponent(this.redirect))
          } else {
            this.$router.replace('/')
          }
        }
        if (operationType === 3) {
          localStorage.setItem('orgList', JSON.stringify(res.data.orgList))
          localStorage.setItem('basicInfo', JSON.stringify({username: this.username, password: this.password}))
          if (this.redirect) {
            this.$router.push({
              path: '/loginSelectOrg',
              query: {
                redirect: decodeURIComponent(this.redirect)
              }
            })
          } else {
            this.$router.push({
              path: '/loginSelectOrg'
            })
          }
        }
        if (operationType === 2) {
          this.$router.push({
            path: '/resetDefaultPwd',
            query: {
              mustResetPwdId: res.data.mustResetPwdId
            }
          })
        }
        if (operationType === 0) {
          this.$Toast.fail(res.msg)
        }
        if (operationType === 1) {
          this.$Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  min-height: 100vh;
  background: #fff;
  padding: 20px;
}
img {
  width: 80px;
  margin: 0 auto;
  display: block;
}
h2 {
  font-size: 16px;
  text-align: center;
  margin-bottom: 60px;
}
div.forget {
  text-align: right;
  font-size: 12px;
  margin-bottom: 20px;
  font-weight: 500;
}
div.regist {
  text-align: center;
  font-size: 12px;
  margin-top: 20px;
  font-weight: 500;
}
</style>
